import { useEffect, useState } from 'react';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
      // There is a bug in Safari + Safari iOS where the inner height/width is
      // not correctly calulated immediately after changing orientation.
      // Because Safari (as the only browser!) doesn't support the
      // Screen Orientation API, we resort to waiting a bit before setting it again.
      setTimeout(() => {
        setWindowWidth(window.innerWidth);
      }, 200);
    }

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowWidth;
};

export default useWindowWidth;
